(() => {
	const articleSelector = "#article";
	const tocMountSelector = "#toc";

	const article = document.querySelector(articleSelector);
	const mount = document.querySelector(tocMountSelector);
	if (!article || !mount) return;

	// 1) 收集标题
	const headings = Array.from(article.querySelectorAll("h2, h3"));
	if (!headings.length) return;

	// 2) 确保每个标题有 id
	const slugify = (s) =>
		(s || "")
			.trim()
			.toLowerCase()
			.replace(/\s+/g, "-")
			.replace(/[^\w\-\u4e00-\u9fa5]+/g, "")
			.replace(/\-+/g, "-")
			.replace(/^\-|\-$/g, "") || "section";

	const used = new Set();
	const ensureId = (el) => {
		if (el.id && !used.has(el.id)) {
			used.add(el.id);
			return;
		}
		const base = slugify(el.textContent);
		let id = base,
			i = 2;
		while (used.has(id) || document.getElementById(id)) id = `${base}-${i++}`;
		el.id = id;
		used.add(id);
	};
	headings.forEach(ensureId);

	// 3) 分组 h2 -> h3
	const groups = [];
	let current = null;
	for (const h of headings) {
		const tag = h.tagName.toLowerCase();
		if (tag === "h2") {
			current = { h2: h, h3s: [] };
			groups.push(current);
		} else if (tag === "h3") {
			if (!current) {
				current = { h2: null, h3s: [] };
				groups.push(current);
			}
			current.h3s.push(h);
		}
	}

	// 4) 创建 TOC DOM
	mount.innerHTML = "";

	const wrapper = document.createElement("div");
	wrapper.className = "group mb-8 border border-black open:bg-white ";

	const summaryBtn = document.createElement("button");
	summaryBtn.type = "button";
	summaryBtn.className =
		"flex justify-between items-center cursor-pointer px-4 py-3 font-bold text-[#000000]  hover:bg-gray-50  transition-colors select-none w-full";
	summaryBtn.setAttribute("aria-expanded", "false");

	const summaryTitle = document.createElement("span");
	summaryTitle.textContent = "Summary";

	const summaryCaret = document.createElement("span");
	summaryCaret.className = "opacity-85";
	summaryCaret.textContent = "▾";

	summaryBtn.appendChild(summaryTitle);
	summaryBtn.appendChild(summaryCaret);

	const body = document.createElement("div");
	body.className = "my-2";
	body.style.display = "none";

	const list = document.createElement("ol");
	list.className = "m-0 pl-0";

	// 创建带序号的链接
	const makeLink = (el, prefix = "", isLevel2 = false) => {
		const a = document.createElement("a");
		a.className = "text-inherit no-underline hover:underline";
		if (isLevel2) {
			a.className += " text-slate-600 "; // 第二级颜色较浅，字体稍小
		} else {
			a.className += " text-black font-bold"; // 第一级颜色更深，字体加粗
		}
		a.href = `#${el.id}`;

		// 获取标题文本并添加序号前缀
		const titleText = (el.textContent || "").trim() || el.id;
		a.textContent = prefix ? `${prefix} ${titleText}` : titleText;

		a.addEventListener("click", (e) => {
			e.preventDefault();
			document.getElementById(el.id)?.scrollIntoView({ behavior: "smooth", block: "start" });
			history.replaceState(null, "", `#${el.id}`);
		});
		return a;
	};

	// 计数器：用于生成序号
	let h2Counter = 0;

	groups.forEach((g) => {
		if (!g.h2) return;

		h2Counter++; // 增加第一级计数器
		const h2Number = h2Counter;

		// 第一级标题
		const h2Li = document.createElement("li");
		h2Li.className = "mb-2";

		// 第一级标题加序号，如 "1. 标题"
		h2Li.appendChild(makeLink(g.h2, `${h2Number}.`, false));

		list.appendChild(h2Li);

		// 如果有第二级标题
		if (g.h3s.length > 0) {
			const h3List = document.createElement("ol");
			h3List.className = "mt-1 mb-3 pl-4"; // 添加左边距实现缩进

			// 第二级标题计数器
			let h3Counter = 0;

			g.h3s.forEach((h3) => {
				h3Counter++; // 增加第二级计数器
				const h3Number = `${h2Number}.${h3Counter}`; // 生成如 "1.1" 的序号

				const h3Li = document.createElement("li");
				h3Li.className = "mb-1";
				// 第二级标题加点加序号，如 "1.1 标题"
				h3Li.appendChild(makeLink(h3, `${h3Number}`, true));
				h3List.appendChild(h3Li);
			});

			list.appendChild(h3List);
		}
	});

	body.appendChild(list);
	wrapper.appendChild(summaryBtn);
	wrapper.appendChild(body);
	mount.appendChild(wrapper);

	// 5) Summary：全局展开/折叠
	const setSummaryExpanded = (expanded) => {
		summaryBtn.setAttribute("aria-expanded", String(expanded));
		body.style.display = expanded ? "block" : "none";
		summaryCaret.textContent = expanded ? "▴" : "▾";
	};

	summaryBtn.addEventListener("click", () => {
		const expanded = summaryBtn.getAttribute("aria-expanded") === "true";
		setSummaryExpanded(!expanded);
	});

	setSummaryExpanded(false);
})();
